var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.15078 2.99961C9.15078 2.64062 8.85977 2.34961 8.50078 2.34961C8.1418 2.34961 7.85078 2.64062 7.85078 2.99961V7.34961H3.50156C3.14258 7.34961 2.85156 7.64062 2.85156 7.99961C2.85156 8.35859 3.14258 8.64961 3.50156 8.64961H7.85078V12.9996C7.85078 13.3586 8.1418 13.6496 8.50078 13.6496C8.85977 13.6496 9.15078 13.3586 9.15078 12.9996V8.64961H13.5016C13.8605 8.64961 14.1516 8.35859 14.1516 7.99961C14.1516 7.64062 13.8605 7.34961 13.5016 7.34961H9.15078V2.99961Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
